export const ContainerTrackingCheckboxGroupData = [
  {
    name: "Container_number",
    value: "Container number",
  },
  {
    name: "Bill_of_lading_number",
    value: "Bill of Lading number",
  },
  {
    name: "Booking_number",
    value: "Booking number",
  },
] as const;

export const AirTrackingCheckboxGroupData = [
  {
    name: "AWB_number",
    value: "AWB number",
  },
  {
    name: "Booking_number",
    value: "Booking number",
  },
] as const;

export const VesselScheduleCheckboxGroupData = [
  {
    name: "By_route",
    value: "By route",
  },
  {
    name: "By_vessel",
    value: "By vessel",
  },
  {
    name: "By_port",
    value: "By port",
  },
];

export const TransitTimeCheckboxGroupData = [
  {
    name: "Sea",
    value: "Sea",
  },
  {
    name: "Road",
    value: "Road",
  },
  {
    name: "Rail",
    value: "Rail",
  },
  {
    name: "Air",
    value: "Air",
  },
];

export const CarbonEmissionsCheckboxGroupShippingTypes = [
  {
    name: "Sea",
    value: "Sea",
  },
  {
    name: "Road",
    value: "Road",
  },
  {
    name: "Rail",
    value: "Rail",
  },
  {
    name: "Air",
    value: "Air",
  },
] as const;

export const CarbonEmissionsCheckboxGroupTypeOfCalculation = [
  {
    name: "BY_COORDINATES",
    value: "BY COORDINATES",
  },
  {
    name: "BY_LINES",
    value: "BY LINES",
  },
] as const;
